// extracted by mini-css-extract-plugin
export default {"container":"peacegame_PeaceFlame_container","canvasWrapper":"peacegame_PeaceFlame_canvasWrapper","canvas":"peacegame_PeaceFlame_canvas"};